import Icon from '../components/Icon.vue'

Icon.register({"plane":{"width":576,"height":512,"paths":[{"d":"M472 200H360.2L256 5.7A12-12 0 0 1 245.8 0H188C180.2 0 174.4 7.4 176.4 15L209.6 200H99.8L64.9 141.8A12-12 0 0 1 54.6 136H12C4.4 136-1.2 142.9 0.2 150.4L21.4 256 0.2 361.6C-1.2 369.1 4.4 376 12 376L54.6 376C58.8 376 62.7 373.8 64.9 370.2L99.8 312H209.6L176.4 497C174.4 504.6 180.2 512 188 512H245.8A12-12 0 0 1 256 506.3L360.2 312H472C529.4 312 576 286.9 576 256S529.4 200 472 200z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/plane.js
// module id = 9HAw
// module chunks = 0